
namespace Matrix.Scheduling {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CalendarEntryDialog extends SiteEntityDialog<CalendarEntryRow, any> {
        protected getFormKey() { return CalendarEntryForm.formKey; }
        protected getIdProperty() { return CalendarEntryRow.idProperty; }
        protected getLocalTextPrefix() { return CalendarEntryRow.localTextPrefix; }
        protected getNameProperty() { return CalendarEntryRow.nameProperty; }
        protected getService() { return CalendarEntryService.baseUrl; }
        protected getDeletePermission() { return CalendarEntryRow.deletePermission; }
        protected getInsertPermission() { return CalendarEntryRow.insertPermission; }
        protected getUpdatePermission() { return CalendarEntryRow.updatePermission; }

        protected form = new CalendarEntryForm(this.idPrefix);

    }
}